import styled from '@emotion/styled';

import { createClassNames } from '@hrworks/design-system/functions';
import { mq, shouldForwardProp } from '@hrworks/design-system/utilities';
import { SidebarToggleStyles } from '@hrworks/sui-core/ClassicLayout';

import type { SqwLayoutProps } from '../SqwLayout.types';

const SidebarToggle = styled(SidebarToggleStyles.SidebarToggle, {
  shouldForwardProp,
})<{
  $desktopSidebarTogglerMode: SqwLayoutProps['desktopSidebarTogglerMode'];
}>(({ $desktopSidebarTogglerMode }) => ({
  ...($desktopSidebarTogglerMode === 'none' && {
    display: 'none',
  }),
  [mq.isSmallDevice]: {
    display: 'inline-flex',
  },
}));

const components = { SidebarToggle };

export const S = {
  ...components,
  ...createClassNames('SqwSidebarToggle', components),
} as const;
